import React, { Component } from "react";
import config from "react-global-configuration";
import msparcs from "assets/img/msparcs.png"; // Make sure to provide the correct path to your image file
import axios from "axios";
import jwt_decode from "jwt-decode";
import * as moment from "moment";
import "./bvp.css";
import logo from "assets/img/Powered_by_Innoviti.png";
function numberFormat(str) {
  console.log(typeof str); // Outputs: "number"
  let num = parseInt(str);
  // Convert number to string with comma separators
  var formattedNumber = num.toLocaleString("en-US", {
    maximumFractionDigits: 0,
  });
  return formattedNumber;
}
class BvpDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFullScreen: false,
      txn_data: [],
      kip_data: {},
      total_sale:0,
      animate: false, // Add animate state to trigger animation
      animate1: false,
      is_show_kpi: false,
      time_interval: 50000,
      currentDate: new Date(),
      total_charity:0
    };
  }

  componentDidMount() {
    const script = document.createElement('script');
    script.src = "https://use.fontawesome.com/releases/v5.0.13/js/all.js";
    script.integrity = "sha384-xymdQtn1n3lH2wcu0qhcdaOpQwyoarkgLVxC/wZ5q7h9gHtxICrpcaSUfygqZGOe";
    script.crossOrigin = "anonymous";
    script.async = true;

    document.body.appendChild(script);
    this.script = script;
    this.intervalID = setInterval(
      () => this.tick(),
      1000
    );
    var data = [
      { id: 1, store_name: "Qasim Communication", amount: 9576, "store_code":'H00842',"city_name":"Mumbai"},
      { id: 2, store_name: "Sri Balaji Traders", amount: 8820, "store_code":'H00845' ,"city_name":"Delhi"},
      { id: 3, store_name: "We Connect - Delhi", amount: 8034, "store_code":'H00842',"city_name":"Gujrat" },
    ];
    axios
      .post(
        config.get("API_URL") + "/summaryReport/mvp_top5_stores/",
        {},
        {
          headers: {
            Authorization: ` ${localStorage.usertoken}`,
          },
        }
      )
      .then((response) => {
        //console.log(response.data)
        console.log(typeof ("ss", response.data.time_interval));
        var total_sale = 0;
        if(response.data.data.length>0){
            total_sale = response.data.data[0].total_amount;
        }
        this.setState({
          txn_data: response.data.data,
          total_sale: total_sale,
          animate: true,
          time_interval: response.data.time_interval,
        });
        var t_interval = response.data.time_interval
          ? response.data.time_interval
          : 50000;
           this.interval = setInterval(() => {
                this.fetchData();
                this.fetchKpi();
           }, t_interval);
           setTimeout(() => {
      this.setState({ animate: false });
    }, 4000);

      });
      this.fetchKpi();
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    clearInterval(this.intervalID);
    document.body.removeChild(this.script);
  }

  fetchData() {
    var data = [
      { id: 1, store_name: "Qasim Communication", amount: 9576 },
      { id: 2, store_name: "Sri Balaji Traders", amount: 8820 },
      { id: 3, store_name: "We Connect - Delhi", amount: 8034 },
      { id: 4, store_name: "Tatvish Techology Llp Gujarat", amount: 7511 },
      { id: 4, store_name: "Eve11", amount: 7209 },
    ];

    axios
      .post(
        config.get("API_URL") + "/summaryReport/mvp_top5_stores/",
        {},
        {
          headers: {
            Authorization: ` ${localStorage.usertoken}`,
          },
        }
      )
      .then((response) => {
        //console.log(response.data)
        console.log(typeof ("ss", response.data.time_interval));
        var total_sale = 0;
        if(response.data.data.length>0){
            total_sale = response.data.data[0].total_amount;
        }
        this.setState({
          txn_data: response.data.data,
          total_sale:total_sale,
          animate: true,
          time_interval: response.data.time_interval,
        });
        // Remove animation class after a short delay
         setTimeout(() => {
      this.setState({ animate: false });
    }, 4000);
      });

  }
  fetchKpi() {
    //console.log("hi000");
    axios
      .post(
        config.get("API_URL") + "/summaryReport/mvp_summary/",
        {},
        {
          headers: {
            Authorization: ` ${localStorage.usertoken}`,
          },
        }
      )
      .then((response) => {
        this.setState({
          kip_data: response.data,
          animate1: true,
          is_show_kpi: true,
        });
        // Remove animation class after a short delay
        setTimeout(() => {
          this.setState({ animate1: false });
        }, 4000);
      });

  }

  toggleFullScreen() {
    const elem = document.getElementById("contentSection");
    if (!this.state.isFullScreen) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen(); /* Firefox */
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen(); /* Chrome, Safari and Opera */
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen(); /* IE/Edge */
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen(); /* Firefox */
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen(); /* Chrome, Safari and Opera */
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen(); /* IE/Edge */
      }
    }

    this.setState((prevState) => ({
      isFullScreen: !prevState.isFullScreen,
    }));
  }
  tick() {
    this.setState({
      currentDate: new Date()
    });
  }
  render() {
    const { currentDate } = this.state;

    // Format the date
    const formattedDate = `${currentDate.getDate().toString().padStart(2, '0')}/${(currentDate.getMonth() + 1).toString().padStart(2, '0')}/${currentDate.getFullYear()}`;

    // Format the time
    let hours = currentDate.getHours();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // Handle midnight
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const formattedTime = `${hours}:${minutes}:${seconds} ${ampm}`;
    return (
      <div>
        <div
          id="contentSection"
          className={this.state.isFullScreen ? "fullscreen-content" : "content"}
        >
          <div className="container-fluid space-container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card p-10 content-svpdash">
                  <h2 className="bvp-heading">The FleaBoard</h2>
                  <div class="sh-t">
                  <table class="dt-table" cellPadding="0" cellSpacing="0">
                  <tr>
                  <td className="dt-table-td">Date: {formattedDate} &nbsp;&nbsp;Time:&nbsp;</td>
                  <td className="dt-table-td">{hours}:</td>
                  <td className="dt-table-td">{minutes}:</td>
                  <td className="dt-table-td-2">{seconds}</td>
                  <td className="dt-table-td">{ampm}</td>
                  </tr>
                  </table>
{/*                   <span className="date-time">Date: {formattedDate} Time:</span> <span className="date-time">{formattedTime}</span> */}
                  </div>
                  <div className="col-md-12">
                    <div className="">
                      <div className="ss1">

                          <div className="col-md-6">
                            <div className="bvp-shadow">
                            <div className="bvp-kip-title-left">
                              Total Charity Collected
                            </div>
                            {this.state.is_show_kpi === true ? (
                              <div
                                className={`bvp-kip-num ${
                                  this.state.animate1 ? "fade-out-enter" : ""
                                }`}
                              >
                                &#8377;{" "}
                                {this.state.kip_data.total_amount
                                  ? numberFormat(
                                      this.state.kip_data.total_amount
                                    )
                                  : 0}{""}
                              </div>
                            ) : null}
                            </div>
                          </div>
                          <div className="col-md-6">
                          <div className="bvp-shadow">
                            <div className="bvp-kip-title-right">
                              Total Sales
                            </div>
                            {this.state.is_show_kpi === true ? (
                              <div
                                className={`bvp-kip-num ${
                                  this.state.animate1 ? "fade-out-enter" : ""
                                }`}
                              >
                                &#8377;{" "}
                                {this.state.total_sale
                                  ? numberFormat(
                                      this.state.total_sale
                                    )
                                  : 0}{""}
                              </div>
                            ) : null}
                          </div>
                          </div>
                          <div className="clearfix"></div>

                      </div>
                    </div>
                  </div>

                  <div className="col-md-12 top-sell">
                  <div className="sell-sep-b"></div>
                  <div className="top-sell-head">Top Sellers</div>
                    <div>
                      {this.state.txn_data.map((item, index) => (
                        <div className="col-md-4">
                          <div class="square-div">
                              <div class="square-content-div">
                                {index+1}
                              </div>
                          </div>

                          <div
                            key={index}
                            className={
                              "bvp-shadow " +
                              (this.state.animate
                                ? index === 2 || index === 1
                                  ? "slide-right-enter"
                                  : "slide-left-enter"
                                : "")
                            }
                          >
                            <div className="img-crown">
                                <i className="fa fa-crown" style={{ fontSize: '30px', color: index === 0 ? '#FFD700' : index === 1 ? '#C0C0C0' : '#CD7F32' }}></i>
                            </div>
                            <div className="round-image">
                                <img
                                  key={index} // Make sure to provide a unique key for each image
                                  src={`https://sparcs.innoviti.com/static/media/${item.store_code}.png`}
                                  alt={`Image for ${item.store_code}`}
                                />

                            </div>
                            <div className="top-sell-title">
                              {item.store_name}
                            </div>
                            <div className="top-sell-city">
                              {item.city_name}
                            </div>
                            <div className="top-sale-score">
                            <span>
                              &#8377;{" "}
                              {item.amount ? numberFormat(item.amount) : ""}
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="clearfix"></div>
                  <div className="powered-by">
                       <span><img src={logo} alt="logo_image" /> </span>
                  </div>
                  <div className="icon-fullscreen">
                    <button onClick={this.toggleFullScreen.bind(this)}>
                      {this.state.isFullScreen ? (
                        <i className="fa fa-compress" aria-hidden="true"></i>
                      ) : (
                        <i className="fa fa-expand" aria-hidden="true"></i>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default BvpDashboard;
